import React, { useEffect, useState, useLocation, useContext, useLayoutEffect } from "react";
import { Container, Col, Row, Tab, Tabs } from "react-bootstrap"; 
import URLstateContext from "../../../provider/CommonContext";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5percent from "@amcharts/amcharts5/percent";
import "./CompanyShareholding.css";


function CompanyShareholding(props, ref) {
    let getCoCode = props.coCode;
    const { BaseURL } = useContext(URLstateContext);
    const [chartyearsData, setyearschartData] = useState([]);
    const [chartdata, setchartdata] = useState([]);
    const [dataFinal, setdataFinal] = useState([]);
    const [chartperiod, setchartperiod] = useState([]);

    useEffect(() => {


        const getUrlchart = BaseURL + "shareholdingpattern";
        if (getCoCode != "") {
            fetch(`${getUrlchart}/${getCoCode}`)
                .then((response) => response.json())
                .then((data) => {
                    setdataFinal(data.data)
                    if (data.data.length > 0) {
                        //console.log("data:" + JSON.stringify(data.data));
                        setchartperiod(data.data[0]["YRC"]);
                        clickchartperiodHandler(data.data[0]["YRC"]);
                    }
                    setyearschartData(data.data);

                    const getUrlchart = BaseURL + "shareholdingpattern/";
                    fetch(`${getUrlchart}/${getCoCode}`)
                        .then((response) => response.json())
                        .then((data) => {
                            if (data.data.length > 0) {
                                //    console.log("data:" + JSON.stringify(data.data));
                                setchartperiod(data.data[0]["YRC"]);
                                clickchartperiodHandler(data.data[0]["YRC"]);
                            }
                            setyearschartData(data.data);


                        })
                        .catch((error) => {
                            //console.log("not found the api");
                        });
                });
            }
    
    

    }, [props.coCode]);
    const clickchartperiodHandler = (priod) => {
        setchartperiod(priod);


        const getUrlchart = BaseURL + "shareholdingpattern_year";

        fetch(`${getUrlchart}/${getCoCode}/${priod}`)
            .then((response) => response.json())
            .then((data) => {

                setchartdata(data.data);
                 

            })
            .catch((error) => {
                // console.log("not found the api");
            });

    }
    useLayoutEffect(() => {
        var root = am5.Root.new("shareHoldingchartdiv");


        //root.setThemes([
        //    am5themes_Animated.new(root)
        //]);


        //var chart = root.container.children.push(am5xy.XYChart.new(root, {
        //    panX: true,
        //    panY: true,
            
        //    pinchZoomX: false
        //}));


        //var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
        //cursor.lineY.set("visible", false);

        //var xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
        
        

        //var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
        //    maxDeviation: 0.3,
        //    categoryField: "country",
        //    renderer: xRenderer,
        //    tooltip: am5.Tooltip.new(root, {})
        //}));

        //var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
        //    maxDeviation: 0.3,
        //    renderer: am5xy.AxisRendererY.new(root, {})
        //}));


        //var series = chart.series.push(am5xy.ColumnSeries.new(root, {
        //    name: "Series 1",
        //    xAxis: xAxis,
        //    yAxis: yAxis,
        //    valueYField: "value",
        //    sequencedInterpolation: true,
        //    categoryXField: "country",
        //    tooltip: am5.Tooltip.new(root, {
        //        labelText: "{valueY}"
        //    })
        //}));
        
        //series.columns.template.setAll({
        //    fillOpacity: 0.5,
        //    strokeWidth: 2,
        //    cornerRadiusTL: 5,
        //    cornerRadiusTR: 5,
        //    width: 50
        //});
        //series.columns.template.adapters.add("fill", function (fill, target) {
        //    return chart.get("colors").getIndex(series.columns.indexOf(target));
        //});

        //series.columns.template.adapters.add("stroke", function (stroke, target) {
        //    return chart.get("colors").getIndex(series.columns.indexOf(target));
        //});

 

        //function generateChartData() {
        //    let chartData = [];
        //    // current date
        //    //let firstDate = new Date();
        //    // now set 500 minutes back
        //    //firstDate.setMinutes(firstDate.getDate() - 500, 0, 0);

        //    // and generate 500 data items
        //    //console.log("chart period:"+chartperiod);
        //    for (var i = 0; i < chartdata.length; i++) {
        //        //let newDate = new Date(chartData[i].upd_date);

        //        chartData.push({
        //            country: chartdata[i].column1.replace(/[_]/g," "),
        //            value: Number(chartdata[i].column2)
        //        });
        //    }

        //    return chartData;
        //}
        ////console.log("ddddd:"+JSON.stringify(generateChartData()));
        //let data = generateChartData();

        //xAxis.data.setAll(data);
        //series.data.setAll(data);


        //series.appear(1000);
        //chart.appear(1000, 100);
        //return () => {
        //    root.dispose();
        //};
        // Set themes
        // https://www.amcharts.com/docs/v5/concepts/themes/
        root.setThemes([
            am5themes_Animated.new(root)
        ]);


        
        var chart = root.container.children.push(am5percent.PieChart.new(root, {
            layout: root.verticalLayout
        }));

     
     
        var series = chart.series.push(am5percent.PieSeries.new(root, {
            valueField: "value",
            categoryField: "category",
            legendLabelText: "[fontSize: 13px]{category}:",
            legendValueText: "[fontSize: 13px]{value}%",
            
        }));
      
        series.get("colors").set("colors", [
            am5.color("#0473ea"),
            am5.color("#3dd307"),
            am5.color("#a3f184"),
            am5.color("#acd1f8"),
            am5.color("#0ad4e6"),
            am5.color("#0aeedf"),
          ]);
       
          function generateChartData() {
            let chartData = [];
            // current date
            //let firstDate = new Date();
            // now set 500 minutes back
            //firstDate.setMinutes(firstDate.getDate() - 500, 0, 0);

            // and generate 500 data items
            //console.log("chart period:"+chartperiod);
            for (var i = 0; i < chartdata.length; i++) {
                //let newDate = new Date(chartData[i].upd_date);

                chartData.push({
                    category: chartdata[i].column1.replace(/[_]/g," "),
                    value: Number(chartdata[i].column2)
                });
            }

            return chartData;
        }
        //console.log("ddddd:"+JSON.stringify(generateChartData()));
        let data = generateChartData();
          
        series.data.setAll(data);
        

        series.ticks.template.set("visible", false);
        series.labels.template.set("forceHidden", true);
        
        var legend = chart.children.push(am5.Legend.new(root, {
            centerY: am5.percent(50),
            x: am5.percent(30),
            layout: root.verticalLayout,
            // legendLabelText: "[{fill}]{category}[/]",
            // legendValueText: "[bold {fill}]{value}[/]"
            dx: -30,
        }));
     
    
        legend.data.setAll(series.dataItems);

           
        series.appear(1000, 100);
         return () => {
            root.dispose();
        };
    }, [chartperiod,chartdata]);
    return (
        <>
            <section className="company-fundamental-section">
                <Container className="add-border table-boxshare">
                    <Row>
                        <Col md={12}>
                            <h4>Share Holding</h4>
                            {(dataFinal === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                            <div>
                                <ul className="day-data">
                                    {chartyearsData && chartyearsData.map(({ YRC, yrcname }) => (
                                        <>
                                            <li className={chartperiod === YRC ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler(YRC)}>{yrcname}</li>
                                        </>
                                    ))}
                                </ul>
                            </div>
                          
                            <div id="shareHoldingchartdiv" style={{ width: "90%", height: "500px" }}></div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}
export default CompanyShareholding;